import React from "react";
import "./Customer.css";
import one from "./testi_s4_ic1@2x.png";
import two from "./testi_s4_ic2@2x.png";
import three from "./user4@2x.png";
import four from "./user6@2x.png";
import five from "./user5@2x.png";
import six from "./Polygon 3@2x.png";
import { FaPlay } from "react-icons/fa";

const Customer = () => {
  return (
    <div className="container py-5 ">
      <div className="row">
        <div className="col-md-6 text-center text-md-start">
          <button className="btn notero-button">Testimonials</button>
          <h1 className="py-3 fw-bolder">
            Loved From <span className="text-color">Customers</span>
          </h1>
          <p className="p-2 ">
            Amar Net Bill loved from thoudsands customer worldwide and get
            trusted from big companies.
          </p>
          <div className="castomer py-2">
            <div>
              <img
                className="img-fluid me-2"
                src={one}
                width={"108px"}
                alt=""
              />
              <h1 className="color fw-bolder py-2">1K+</h1>
              <p>
                Downloaded and <br />
                Installation
              </p>
            </div>

            <div>
              <img className="img-fluid ms-3" src={two} width={"90px"} alt="" />
              <h1 className="color fw-bolder pt-2">4.8/5</h1>
              <p className="star"> &#9733; &#9733; &#9733; &#9733; &#9733;</p>
              <p>Based on 958 reviews</p>
            </div>
          </div>
          <div className="row">
            <div className="col pt-2">
              {/* <button className="btn py-3 comon rounded-pill ">
                See Reviews on app store
              </button> */}
              <button className="downloadBtn rounded-pill">
                <div className="d-flex  text-center align-items-center ">
                  <div className="down px-2">
                    <img className="tmg-fluid" src={one} alt="" />
                  </div>
                  <div>
                    <p className="mt-3 ">
                      {" "}
                      <span className="ps-3">|</span> Download App
                    </p>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
        <div id="world" className="col-md-6">
          <div className="d-flex align-items-center lh-1 shadow p-2 me-sm-5 mb-5 bg-body-tertiary rounded">
            <div>
              <img src={three} width={"92px"} alt="" />
            </div>
            <div>
              <p className="star"> &#9733; &#9733; &#9733; &#9733; &#9733; </p>
              <p className="text-small">
                "Managing all my client bills in one app has never been easier.
                I can track payments, send reminders, and stay organized
                effortlessly."
              </p>
              <p className="another-text">
                {" "}
                <small>
                  Md. RAHUL / <span className="another-color">ISP Owner</span>
                </small>
              </p>
            </div>
          </div>
          <div className="d-flex align-items-center lh-1 shadow p-2 mb-5 ms-sm-5 bg-body-tertiary rounded">
            <div>
              <img src={five} width={"92px"} alt="" />
            </div>
            <div>
              <p className="star"> &#9733; &#9733; &#9733; &#9733; &#9733; </p>
              <p className="text-small">
                "Setting up clients, monitoring bills, and sending notifications
                is all done in minutes. Truly a lifesaver for ISP management."
              </p>
              <p className="another-text">
                {" "}
                <small>
                  ARIF Hasan. /{" "}
                  <span className="another-color">
                    {" "}
                    System Administrator
                  </span>{" "}
                </small>
              </p>
            </div>
          </div>
          <div className="d-flex align-items-center lh-1 shadow p-2 me-sm-5 mb-5 bg-body-tertiary rounded">
            <div>
              <img src={four} width={"92px"} alt="" />
            </div>
            <div>
              <p className="star"> &#9733; &#9733; &#9733; &#9733; &#9733; </p>
              <p className="text-small">
                "Thanks to this app, tracking client payments and generating
                invoices is now effortless. It saves us time and keeps
                everything organized in one place."
              </p>
              <p className="another-text">
                {" "}
                <small>
                  Kamrul Hasan
                  <span className="another-color">
                    {" "}
                    Client Relations Manager
                  </span>
                </small>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Customer;
